// extracted by mini-css-extract-plugin
module.exports = {"tabArea":"classes_tabArea__iHFlk","tabContents":"classes_tabContents__Wf5wc","hidden":"classes_hidden__3cQDa","tabAreaHeight":"classes_tabAreaHeight__1Su46"};